import React, { useMemo } from 'react';
import { Box } from '@mui/material';
import { useAsyncValue } from 'framework/utils';
import { useArtifactService, API_FILE_TYPE, CROP_SIZES } from 'domain/shared/artifact';
import { DefaultUserAvatar } from 'framework/ui/mui-builder';

interface EmployeePhotoDisplayProps {
  photosIds?: string[];
}

const IMAGE_STYLE: React.CSSProperties = {
  width: '100%',
  height: '100%',
  borderRadius: '4px',
  objectFit: 'cover',
};

const EmployeePhotoDisplay: React.FC<EmployeePhotoDisplayProps> = ({ photosIds }) => {
  const { getArtifactDataById } = useArtifactService();
  const avatarId = photosIds?.[0] ?? null;

  const artifact = useAsyncValue(async () => (avatarId ? getArtifactDataById(avatarId) : null), [avatarId]);

  const photoElement = useMemo(() => {
    const image = Array.isArray(artifact) ? artifact[0] : artifact;
    if (!image || image.type !== API_FILE_TYPE.image.alias) {
      return <DefaultUserAvatar style={IMAGE_STYLE} />;
    }

    const thumbnail = image.thumbnails?.[CROP_SIZES.SIZE_100] || image.filePreview;

    return <img src={thumbnail} alt={image.title} title={image.title} id={image.id} style={IMAGE_STYLE} />;
  }, [artifact]);

  return (
    <Box
      display="flex"
      alignItems="center"
      justifyContent="center"
      position="relative"
      sx={{ aspectRatio: 1, height: '100px' }}
    >
      {photoElement}
    </Box>
  );
};

export default EmployeePhotoDisplay;
